import { InputNumber, type InputNumberProps } from 'antd'
import { MAX_WHOLE_KRW_AMOUNT, MAX_WHOLE_QUANTITY } from '@repo/shared'

/**
 * 금액·수량 입력 칸 (개발항목 307 S2).
 *
 * 서버는 금액을 1억 원 미만의 원 단위 정수로, 수량을 999,999 이하의 정수로만 받는다(개발항목 291).
 * 입력 칸이 소수·상한 초과를 그대로 받으면 저장 때 400으로 거절되므로, 금액·수량 칸은 모두 이 모듈을
 * 거쳐 소수점 없이(`precision={0}`) 0 이상 상한 이하만 넣게 한다. 상한은 서버와 같은 공용 상수
 * (`@repo/shared`의 `MAX_WHOLE_KRW_AMOUNT`·`MAX_WHOLE_QUANTITY`)다. antd `InputNumber`를 화면에서
 * 직접 쓰지 않는다(ESLint `no-restricted-imports`).
 */
type WholeNumberInputProps = Omit<InputNumberProps<number>, 'precision' | 'max' | 'stringMode'>

/** 원 단위 금액(가격·배송비) — 0 이상 {@link MAX_WHOLE_KRW_AMOUNT} 이하의 정수. */
export function KrwAmountInput({ min = 0, ...props }: WholeNumberInputProps) {
  return (
    <InputNumber<number>
      addonAfter="KRW"
      {...props}
      min={min}
      max={MAX_WHOLE_KRW_AMOUNT}
      precision={0}
    />
  )
}

/** 수량(재고) — 0 이상 {@link MAX_WHOLE_QUANTITY} 이하의 정수. */
export function QuantityInput({ min = 0, ...props }: WholeNumberInputProps) {
  return <InputNumber<number> {...props} min={min} max={MAX_WHOLE_QUANTITY} precision={0} />
}
